import { axios } from '@lib/axios';
import {
    OfficeScheduleSettingsListResponse,
    OfficeScheduleSettingsViewModel,
    OfficeScheduleSettingsUpsertParams,
} from 'chaika-types';

const BASE_URL = '/api/office-schedule-settings';

export class OfficeScheduleSettingsApi {
    public static async find(officeIds: string[]): Promise<OfficeScheduleSettingsViewModel[]> {
        const res = await axios.get<OfficeScheduleSettingsListResponse>(`${BASE_URL}`, {
            params: { officeIds: officeIds.join(',') },
        });

        return res.data.settings;
    }

    public static async upsert(officeId: string, settings: OfficeScheduleSettingsUpsertParams): Promise<void> {
        await axios.put(`${BASE_URL}/${officeId}`, { settings });
    }
}
